module.exports = __webpack_public_path__ + "media/images/faces/male/9-27fab9bccc854f3624d8c103dd623db9.jpg";